import { createFileRoute } from "@tanstack/react-router";
import { SpokePage, buildSpokeHead, type SpokePageConfig } from "@/components/SpokePage";
import heroImg from "@/assets/towns/denver.jpg";

const CONFIG: SpokePageConfig = {
  slug: "denver-seo",
  metaTitle: "Denver SEO Services | Local SEO From $950/mo",
  metaDescription: "Denver SEO for local businesses: Google Maps, local SEO and AI search from $950/month, month-to-month. 27 years helping businesses reach page one.",
  breadcrumbs: [{ label: "Home", to: "/" }, { label: "Colorado SEO", to: "/colorado-seo" }],
  currentLabel: "Denver SEO",
  eyebrow: "SEO Services — Denver, CO",
  h1: (
    <>
      <span className="text-brand-gold">Denver SEO</span> That Brings In Calls
    </>
  ),
  heroDescription: "Local SEO, Google Maps and AI search for Denver businesses — month-to-month.",
  intro: "Denver is one of the most crowded search markets in Colorado. Digital Marketing Coach Chris Heidlebaugh has spent 27 years helping businesses move from pages 6–10 of Google to page one. We focus on free leads first — your website, Google Maps, AI search and social media — with published, month-to-month plans.",
  definition: { term: "Denver SEO", body: "Work that helps Denver customers find your business on Google, Google Maps and AI tools when they search for what you offer." },
  whatWeDo: [
    { title: "Starter — $950/mo", body: "Local SEO and Google Maps." },
    { title: "Growth — $1,650/mo", body: "Adds AI search and social media." },
    { title: "Expert — $2,750/mo", body: "Multi-city SEO, Maps, AI, social, PPC and reputation management. Ad spend not included." },
    { title: "Neighborhood pages", body: "Pages for the Denver areas you actually serve." },
    { title: "Google Maps", body: "Profile, photos, reviews and steady updates." },
    { title: "Free audit", body: "See what holds your Denver rankings back." },
  ],
  whyThisMarket: [
    { heading: "Crowded results", body: "Many businesses compete for each search, so clear pages per service and area matter." },
    { heading: "Maps drive calls", body: "Denver buyers often call straight from the map results." },
    { heading: "No locked contracts", body: "Month-to-month plans. You stay because it works." },
  ],
  relatedLinks: [
    { to: "/colorado-seo", label: "Colorado SEO" },
    { to: "/pueblo-seo", label: "Pueblo SEO" },
    { to: "/colorado-springs-seo", label: "Colorado Springs SEO" },
    { to: "/denver-roofing-marketing", label: "Denver roofing marketing" },
    { to: "/pricing", label: "Pricing" },
    { to: "/free-audit", label: "Get a free marketing audit" },
  ],
  faqs: [
    { q: "How much does SEO cost in Denver?", a: "Our plans are $950/month (Starter), $1,650/month (Growth) and $2,750/month (Expert), all month-to-month." },
    { q: "Are you based in Denver?", a: "Our office is on Woodmen Rd in Colorado Springs, and we serve Denver and the rest of Colorado." },
    { q: "Can you guarantee page one in Denver?", a: "No one can honestly guarantee a ranking. We focus on the work that moves rankings and brings calls." },
  ],
  serviceName: "Denver SEO Services",
  serviceDescription: "Local SEO, Google Maps and AI search for Denver businesses from $950/month, month-to-month.",
  heroImage: { src: heroImg, alt: "Denver, Colorado skyline with the Rocky Mountains", geo: { lat: 39.7392, lng: -104.9903, city: "Denver, CO" } },
  areaServed: "Denver, CO",
};

export const Route = createFileRoute("/denver-seo")({
  head: () => buildSpokeHead(CONFIG),
  component: () => <SpokePage config={CONFIG} />,
});
